module.exports = __webpack_public_path__ + "static/img/loginimg.85feb8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/loginimg.png
// module id = 7GWL
// module chunks = 1